import React from 'react';
import { Card } from './ui/card';
import { useLanguage } from '../contexts/LanguageContext';
import { stats, certifications } from '../mockData';

const AboutSection = () => {
  const { t } = useLanguage();
  
  return (
    <section id="about" className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{t.about.title}</h2>
          <div className="w-20 h-1 bg-teal-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t.about.description}
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          <Card className="p-6 text-center hover:shadow-xl transition-shadow border-t-4 border-teal-600">
            <div className="text-4xl font-bold text-teal-600 mb-2">25+</div>
            <div className="text-sm text-gray-600 font-medium">{t.about.stats.experience}</div>
          </Card>
          <Card className="p-6 text-center hover:shadow-xl transition-shadow border-t-4 border-teal-600">
            <div className="text-4xl font-bold text-teal-600 mb-2">7000+</div>
            <div className="text-sm text-gray-600 font-medium">{t.about.stats.capacity}</div>
          </Card>
          <Card className="p-6 text-center hover:shadow-xl transition-shadow border-t-4 border-teal-600">
            <div className="text-4xl font-bold text-teal-600 mb-2">%100</div>
            <div className="text-sm text-gray-600 font-medium">{t.about.stats.satisfaction}</div>
          </Card>
          <Card className="p-6 text-center hover:shadow-xl transition-shadow border-t-4 border-teal-600">
            <div className="text-4xl font-bold text-teal-600 mb-2">15+</div>
            <div className="text-sm text-gray-600 font-medium">{t.about.stats.countries}</div>
          </Card>
        </div>

        {/* Content Grid */}
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Column - Text */}
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              {t.about.contentTitle}
            </h3>
            <div className="space-y-4 text-gray-600">
              <p>{t.about.content1}</p>
              <p>{t.about.content2}</p>
              <p>{t.about.content3}</p>
            </div>
          </div>

          {/* Right Column - Certifications */}
          <div>
            <Card className="p-8 bg-gradient-to-br from-teal-50 to-slate-50 border-2 border-teal-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                {t.about.certificationsTitle}
              </h3>
              <div className="grid grid-cols-2 gap-4 mb-6">
                {certifications.map((cert, index) => (
                  <div
                    key={index}
                    className="bg-white p-4 rounded-lg shadow-sm border border-teal-100 text-center"
                  >
                    <div className="text-lg font-bold text-teal-600">{cert}</div>
                  </div>
                ))}
              </div>
              <p className="text-sm text-gray-600">
                {t.about.certificationsDesc}
              </p>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;